import businessType from './business-type'
import businessCategory from './business-category'
import partner from './partner'

export default [
  ...partner, ...businessType, ...businessCategory,
]
